import { differenceInDays, isAfter, subDays } from 'date-fns';
import { getDateFromApiDate } from '@general/dates';

/**
 * @param {string} paidThru e.g. "2021-03-31T04:00:00-04:00"
 */
const getIsMembershipExpiringSoon = paidThru => {
    const paidThruDate = getDateFromApiDate(paidThru);
    const daysUntilPaidThru = differenceInDays(paidThruDate, Date.now());
    return daysUntilPaidThru <= 30;
};

export const convertMemberTypeTextToCode = memberType => {
    switch (memberType) {
        case 'Retailer':
            return 'RM';
        case 'Student':
            return 'SM';
        case 'Academics':
            return 'AC';
        case 'Associate':
            return 'AM';
        case 'NonMember':
            return 'NM';
        case 'Public Sector':
            return 'PB';
        case 'Prospect':
            return 'PROS';
        case 'Regular':
            return 'RM';
        case 'Special Comp':
            return 'SC';
        case 'Un-sponsored':
            return 'SC';
        default:
            return null;
    }
};

/**
 * @param {string} status Active|Inactive
 * @param {string} paidThru e.g. "2021-03-31T04:00:00-04:00"
 * */
export const getMemberStatusText = (status, paidThru) => {
    const isExpiringSoon = getIsMembershipExpiringSoon(paidThru);

    if (status === 'Active' && !isExpiringSoon) {
        return 'Active';
    }

    if (status === 'Active' && isExpiringSoon) {
        return 'Expiring Soon';
    }

    return 'Inactive';
};

export const getMemberMainAddress = addresses => addresses.find(address => address.purpose === 'main');

export const isNewMember = createdAt => {
    const dateThreshold = subDays(new Date(), 10);

    return isAfter(new Date(createdAt), dateThreshold);
};

export const hasNewProperties = () => false;

export const getMemberInfoBreadcrumbLink = (cart, viewerRecordId) => {
    const memberInfoUrl = '/cart/account-info';

    // TODO: Make sure this cart link works properly for all scenarios
    if (cart.items.length === 0) {
        return `${memberInfoUrl}/${cart.member_id}`;
    }

    if (cart.items.some(item => item.member_id === viewerRecordId)) {
        return `${memberInfoUrl}/${viewerRecordId}`;
    }

    return `${memberInfoUrl}/${cart.items[0].member_id}`;
};

export const isNewMatch = hit => {
    const now = new Date();
    const daysAgo = now.setDate(now.getDate() - 7).valueOf() / 1000;
    return hit?.savedSearch?.createdAtTimestamp > daysAgo;
};
